import Swal from "sweetalert2";

type errorMessage = {
    title: string
    body: string,
}

function redirect(url: string): void {
    if(url){
        window.location.replace((window as any).ENV.URL_FRONT + "ListaConcursos")
    }
}

export function handleLoadingConcursoError(error, url) {
    const message = getLoadingConcursosErrorMessage(error)
    Swal.fire({
        icon: 'error',
        title: message.title,
        html: message.body
    }).then(() => redirect(url));
}

function getLoadingConcursosErrorMessage(error): errorMessage {
    if (error.response) {
        if (error.response.status === 500) {
            return {
                title: "Ocurrió un error en nuestros servidores",
                body: "<div>Pulse OK para volver a cargar esta página.<br/>Si el problema persiste, contacte a la Mesa de Ayuda.</div>"
            }
        }
        if (error.response.status === 404) {
            return {
                title: "La página a la que intenta acceder fue eliminada o no existe",
                body: "Si el problema persiste, contacte a la Mesa de Ayuda."
            }
        }
    } else if (error.message === "Network Error") {
        return {
            title: "No se pudo establecer la conexión con nuestros servidores",
            body: "Revise su conexión a internet e intente nuevamente, y si el error aún persiste, intente nuevamente más tarde"
        }
    }
    return {
        title: "Ocurrió un error desconocido",
        body: "Si el problema persiste, contacte a la Mesa de Ayuda"
    }
}

export function handleConcursosDetailError(error) {
    const message = getConcursosDetailsErrorMessage(error)
    Swal.fire({
        icon: 'error',
        title: message.title,
        html: message.body
    }).then();
}

function getConcursosDetailsErrorMessage(error): errorMessage {
    if (error.response) {
        if (error.response.status === 500) {
            return {
                title: "Ocurrió un error en nuestros servidores",
                body: "<div>Por favor vuelva a intentarlo.<br/>Si el problema persiste, contacte a la Mesa de Ayuda.</div>"
            }
        }
        if (error.response.status === 404) {
            return {
                title: "El concurso fue eliminado o no existe",
                body: "Por favor intente crear otro concurso."
            }
        }
    } else if (error.message === "Network Error") {
        return {
            title: "No se pudo establecer la conexión con nuestros servidores",
            body: "Revise su conexión a internet e intente nuevamente, y si el error aún persiste, intente nuevamente más tarde"
        }
    }
    return {
        title: "Ocurrió un error desconocido",
        body: "Si el problema persiste, contacte a la Mesa de Ayuda"
    }
}

export function handleCreateConcursoError(error) {
    const message = getCreateConcursoErrorMessage(error)
    Swal.fire({
        icon: 'error',
        title: message.title,
        html: message.body
    }).then();
}

function getCreateConcursoErrorMessage(error): errorMessage {
    if (error.response) {
        if (error.response.status === 500) {
            return {
                title: "Ocurrió un error en nuestros servidores",
                body: "<div>Por favor vuelva a intentarlo.<br/>Si el problema persiste, contacte a la Mesa de Ayuda</div>"
            }
        }
        if (error.response.status === 404) {
            return {
                title: "Este servicio fue eliminado o no existe",
                body: "<div>Por favor vuelva a intentarlo.<br/>Si el problema persiste, contacte a la Mesa de Ayuda</div>"
            }
        }
    } else if (error.message === "Network Error") {
        return {
            title: "No se pudo establecer la conexión con nuestros servidores",
            body: "Revise su conexión a internet e intente nuevamente, y si el error aún persiste, intente nuevamente más tarde"
        }
    }
    return {
        title: "Ocurrió un error desconocido",
        body: "Si el problema persiste, contacte a la Mesa de Ayuda"
    }
}

export function handleDownloadFileError(error) {
    const message = getDownloadFileErrorMessage(error)
    Swal.fire({
        icon: 'error',
        title: message.title,
        html: message.body
    }).then();
}

function getDownloadFileErrorMessage(error): errorMessage {
    if (error.response) {
        if (error.response.status === 500) {
            return {
                title: "Ocurrió un error en nuestros servidores",
                body: "<div>Por favor vuelva a intentarlo.<br/>Si el problema persiste, contacte a la Mesa de Ayuda</div>"
            }
        }
        if (error.response.status === 404) {
            return {
                title: "El archivo fue eliminado o no existe",
                body: "<div>Por favor inténtelo más tarde.<br/>Si el problema persiste, contacte a la Mesa de Ayuda</div>"
            }
        }
    } else if (error.message === "Network Error") {
        return {
            title: "No se pudo establecer la conexión con nuestros servidores",
            body: "Revise su conexión a internet e intente nuevamente, y si el error aún persiste, intente nuevamente más tarde"
        }
    }
    return {
        title: "Ocurrió un error desconocido",
        body: "Si el problema persiste, contacte a la Mesa de Ayuda"
    }
}

export function handlePostulacionError(error) {
    const message = getPostulacionErrorMessage(error)
    Swal.fire({
        icon: 'error',
        title: message.title,
        html: message.body
    }).then();
}

function getPostulacionErrorMessage(error): errorMessage {
    if (error.response) {
        if (error.response.status === 500) {
            return {
                title: "Ocurrió un error en nuestros servidores",
                body: "<div>Por favor vuelva a intentarlo.<br/>Si el problema persiste, contacte a la Mesa de Ayuda</div>"
            }
        }
        if (error.response.status === 404) {
            return {
                title: "El concurso fue eliminado o no existe",
                body: "<div>Por favor inténtelo más tarde.<br/>Si el problema persiste, contacte a la Mesa de Ayuda</div>"
            }
        }
    } else if (error.message === "Network Error") {
        return {
            title: "No se pudo establecer la conexión con nuestros servidores",
            body: "Revise su conexión a internet e intente nuevamente, y si el error aún persiste, intente nuevamente más tarde"
        }
    }
    return {
        title: "Ocurrió un error desconocido",
        body: "Si el problema persiste, contacte a la Mesa de Ayuda"
    }
}

export function handleServerError() {
    Swal.fire({
        icon: 'error',
        title: "Ocurrió un error en nuestros servidores",
        html: "<div>Por favor vuelva a intentarlo.<br/>Si el problema persiste, contacte a la Mesa de Ayuda</div>"
    }).then();

}

export function handlePostularError(error, correo) {
    const message = getPostularErrorMessage(error, correo)
    if (error.response.status === 406) {
        Swal.fire({
            icon: 'warning',
            title: message.title,
            html: message.body,
            onClose(popup: HTMLElement) {
                redirectToHome()
            }
        }).then();
    } else {
        Swal.fire({
            icon: 'error',
            title: message.title,
            html: message.body
        }).then();
    }
}

function getPostularErrorMessage(error, correo): errorMessage {
    if (error.response) {
        if (error.response.status === 500) {
            return {
                title: "Ocurrió un error en nuestros servidores",
                body: "<div>Por favor vuelva a intentarlo.<br/>Si el problema persiste, contacte a la Mesa de Ayuda</div>"
            }
        }
        if (error.response.status === 404) {
            return {
                title: "El concurso al que intenta postular fue eliminado o no existe",
                body: "<div>Por favor inténtelo más tarde.<br/>Si el problema persiste, contacte a la Mesa de Ayuda</div>"
            }
        }
        if (error.response.status === 406) {
            return {
                title: "Error, número de documento ya ingresado",
                body: "<div>El número de documento ingresado ya se encuentra asociado a una postulación.<br/>En caso de no tener acceso al link de edición por favor comuníquese con " + correo + "</div>"
            }
        }
        if (error.response.status === 400) {
            return {
                title: "El formulario presenta errores",
                body: "<div>Hubo un error en el formulario<br/>Si necesita a asistancia, puede escribir a " + correo + "</div>"
            }
        }
    } else if (error.message === "Network Error") {
        return {
            title: "No se pudo establecer la conexión con nuestros servidores",
            body: "Revise su conexión a internet e intente nuevamente, y si el error aún persiste, intente nuevamente más tarde"
        }
    }
    return {
        title: "Ocurrió un error desconocido",
        body: "Si el problema persiste, contacte a la Mesa de Ayuda"
    }
}

export function handleEdicionConcursoError(error) {
    const message = getEdicionConcursoErrorMessage(error)
    Swal.fire({
        icon: 'error',
        title: message.title,
        html: message.body
    }).then();
}

function getEdicionConcursoErrorMessage(error): errorMessage {
    if (error.response) {
        if (error.response.status === 500) {
            return {
                title: "Ocurrió un error en nuestros servidores",
                body: "<div>Por favor vuelva a intentarlo.<br/>Si el problema persiste, contacte a la Mesa de Ayuda</div>"
            }
        }
        if (error.response.status === 404) {
            return {
                title: "Postulación no encontrada",
                body: "El link de postulación no es válido, o el concurso fue eliminado."
            }
        }
        if (error.response.status === 410) {
            return {
                title: "El concurso ha cerrado",
                body: "No es posible cargar su postulación, porque el período de postulación para este concurso ha terminado."
            }
        }
    } else if (error.message === "Network Error") {
        return {
            title: "No se pudo establecer la conexión con nuestros servidores",
            body: "Revise su conexión a internet e intente nuevamente, y si el error aún persiste, intente nuevamente más tarde"
        }
    }
    return {
        title: "Ocurrió un error desconocido",
        body: "Si el problema persiste, contacte a la Mesa de Ayuda"
    }
}

function redirectToHome() {
    window.location.href = "/ListaConcursos/"
}
